module.exports = __webpack_public_path__ + "img/plus_button.e49fd9b6.svg";